import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, sizes } from '@/utils'

import button from '@/components/button'
import fileItemCard from '@/components/file/item/card'
import fileManager from '@/components/file/manager'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'
import tag from '@/components/tag'

const items = [
  'privacyPolicy',
  'publicOffer'
]

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: icons.settings,
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderItemLabel(h, options, field) {
  const { path, serviceName, defaults } = options
  const key = `${path}.${field}`

  let itemButtonLabel
  let itemButtonColor
  if (this.proxy[field]) {
    itemButtonLabel = this.getTranslate('misc.buttons.remove')
    itemButtonColor = Colors.error
  } else {
    itemButtonLabel = this.getTranslate('misc.buttons.upload')
    itemButtonColor = Colors.primary
  }

  return h(
    'div',
    {
      class: 'grid grid-gap--4 fjcsb',
      style: { gridTemplateColumns: '1fr auto' }
    },
    [
      h(
        tag,
        {
          props: {
            label: this.getTranslate(`${serviceName}.labels.${key}`)
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: itemButtonLabel,
            mode: buttonModes.flat,
            size: sizes.small,
            color: itemButtonColor
          },
          on: {
            click: () => {
              if (this.proxy[field]) {
                this.$emit('input', defaults[key], key)
              } else {
                this.field = field
                this.showFileManager = true
              }
            }
          }
        }
      )
    ]
  )
}
function renderItemContent(h, field) {
  if (this.proxy[field]) {
    return h(
      fileItemCard,
      {
        props: {
          value: this.proxy[field],
          readonly: true
        }
      }
    )
  }

  return h(
    components.card,
    {
      class: 'pa-2',
      props: {
        dashed: true,
        outline: true,
        rounded: true
      }
    },
    [
      h(
        components.empty,
        {
          props: {
            padless: true
          }
        }
      )
    ]
  )
}
function renderItem(h, options, item) {
  return h(
    'div',
    {
      class: 'grid grid-gap--4'
    },
    [
      renderItemLabel.call(this, h, options, item),
      renderItemContent.call(this, h, item)
    ]
  )
}
function renderItems(h, options) {
  return items.map(item => {
    return renderItem.call(this, h, options, item)
  })
}
function renderFileManager(h, options) {
  const { path } = options

  return h(
    fileManager,
    {
      props: {
        flat: true,
        readonly: true,
        embedded: true,
        isPublic: true,
        show: this.showFileManager,
        types: [ 'doc', 'docx', 'pdf' ]
      },
      on: {
        show: event => {
          this.showFileManager = event
        },
        input: event => {
          this.$emit('input', event.id, `${path}.${this.field}`)
          this.showFileManager = false
        },
        finish: event => {
          this.$emit('input', event.id, `${path}.${this.field}`)
          this.showFileManager = false
        }
      }
    }
  )
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 pa-2'
    },
    [
      renderItems.call(this, h, options),
      renderFileManager.call(this, h, options)
    ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderBody.call(this, h, options)
        }
      }
    }
  )
}
